import React, { useEffect, useState } from 'react';
import ClientPortalLayout from './Layout';
import { clientPortalFetch } from './api';
import { formatCurrency, formatDate, StatusPill } from './Dashboard';

const NAVY = '#0f1f45';

function ReferralInner() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    clientPortalFetch('/referral').then(setData).catch((e) => setError(e.message)).finally(() => setLoading(false));
  }, []);

  if (loading) return <p style={{ color: '#9ca3af', fontSize: 13 }}>Loading…</p>;
  if (error) return <p style={{ color: '#9ca3af', fontSize: 13 }}>{error}</p>;
  if (!data) return null;

  const { partner, commissions, redemptions } = data;

  return (
    <div>
      <div className="cp-cards" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 28 }}>
        <StatCard label="Credit Balance" value={formatCurrency(partner.credit_balance)} accent={NAVY} />
        <StatCard label="Total Earned" value={formatCurrency(partner.total_earned)} accent="#16a34a" />
        <StatCard label="Total Redeemed" value={formatCurrency(partner.total_redeemed)} accent="#6b7280" />
      </div>

      <div style={{ background: '#fff', borderRadius: 14, padding: '18px 20px', marginBottom: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <div style={{ fontSize: 12, color: '#9ca3af' }}>Partner ID</div>
        <div style={{ fontSize: 14, fontWeight: 600, color: NAVY, marginTop: 2 }}>{partner.referral_partner_id}</div>
        <div style={{ fontSize: 12, color: '#9ca3af', marginTop: 10 }}>
          Commission: {partner.commission_type === 'percentage' ? `${partner.commission_value}%` : formatCurrency(partner.commission_value)} on {partner.commission_on}
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 14, padding: '20px 22px', marginBottom: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <h3 style={{ fontSize: 15, fontWeight: 700, color: NAVY, margin: '0 0 14px' }}>Commissions</h3>
        {commissions.length === 0 && <p style={{ color: '#9ca3af', fontSize: 13 }}>No commissions yet.</p>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {commissions.map((c) => (
            <div key={c.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, color: '#111827' }}>{c.service_name || 'Referral commission'}</div>
                <div style={{ fontSize: 12, color: '#9ca3af' }}>{formatDate(c.created_at)}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: NAVY }}>{formatCurrency(c.commission_amount)}</div>
                <StatusPill status={c.status} />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ background: '#fff', borderRadius: 14, padding: '20px 22px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        <h3 style={{ fontSize: 15, fontWeight: 700, color: NAVY, margin: '0 0 14px' }}>Redemptions</h3>
        {redemptions.length === 0 && <p style={{ color: '#9ca3af', fontSize: 13 }}>No redemptions yet.</p>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {redemptions.map((r) => (
            <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500, color: '#111827', textTransform: 'capitalize' }}>{r.redemption_type}</div>
                <div style={{ fontSize: 12, color: '#9ca3af' }}>{formatDate(r.processed_at)}</div>
              </div>
              <div style={{ fontSize: 14, fontWeight: 700, color: NAVY }}>{formatCurrency(r.total_amount)}</div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 700px) {
          .cp-cards { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}

const StatCard = ({ label, value, accent }) => (
  <div style={{ background: '#fff', borderRadius: 14, padding: '20px 22px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
    <div style={{ fontSize: 12, color: '#9ca3af', fontWeight: 500, marginBottom: 8 }}>{label}</div>
    <div style={{ fontSize: 22, fontWeight: 700, color: accent || NAVY }}>{value}</div>
  </div>
);

function Referral() {
  return <ClientPortalLayout title="Referral Commissions"><ReferralInner /></ClientPortalLayout>;
}

export default Referral;
